import React from "react";

import ImageGrid from "./containers/ImageGrid";

const HomeRoute: React.FC = () => {

  return (
    <>
      <ImageGrid/>
    </>
  );
};

export default HomeRoute;
